"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogFooter = exports.StyledDialogContent = exports.StyledDialogBody = exports.StyledDialogHeader = exports.StyledDialogHeaderTitle = exports.StyledDialog = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const WindowClose_1 = require("../controls/WindowClose");
const typographyReset_1 = require("../DesignSystem/styles/typographyReset");
const Typography_1 = require("../DesignSystem/tokens/global/Typography");
const Dialog_1 = require("./designTokens/Dialog");
const types_1 = require("./types");
const View_1 = require("../View");
const isSize = (value) => {
    return !!(value && value.width && value.height);
};
const getSize = (value, type) => {
    if (typeof value === 'object' && isSize(value) && type === 'width') {
        return value.width;
    }
    if (typeof value === 'object' && isSize(value) && type === 'height') {
        return value.height;
    }
    if (typeof value === 'string') {
        return value;
    }
    return types_1.DIALOG_SIZE.m;
};
const dialogSizeStyles = {
    xxs: {
        width: Dialog_1.dialogTokens.dialogSizeXXSWidth.getVar(),
        height: Dialog_1.dialogTokens.dialogSizeXXSHeight.getVar()
    },
    xs: {
        width: Dialog_1.dialogTokens.dialogSizeXSWidth.getVar(),
        height: Dialog_1.dialogTokens.dialogSizeXSHeight.getVar()
    },
    s: {
        width: Dialog_1.dialogTokens.dialogSizeSWidth.getVar(),
        height: Dialog_1.dialogTokens.dialogSizeSHeight.getVar()
    },
    m: {
        width: Dialog_1.dialogTokens.dialogSizeMWidth.getVar(),
        height: Dialog_1.dialogTokens.dialogSizeMHeight.getVar()
    },
    l: {
        width: Dialog_1.dialogTokens.dialogSizeLWidth.getVar(),
        height: Dialog_1.dialogTokens.dialogSizeLHeight.getVar()
    },
    xl: {
        width: Dialog_1.dialogTokens.dialogSizeXLWidth.getVar(),
        height: Dialog_1.dialogTokens.dialogSizeXLHeight.getVar()
    },
    xxl: {
        width: Dialog_1.dialogTokens.dialogSizeXXLWidth.getVar(),
        height: Dialog_1.dialogTokens.dialogSizeXXLHeight.getVar()
    },
    auto: {
        width: 'auto',
        height: 'auto'
    }
};
const setDialogSizeStyles = (size) => {
    var _a, _b;
    if (typeof size === 'object' && isSize(size)) {
        return (0, styled_components_1.css) `
            width: ${((_a = dialogSizeStyles[getSize(size, 'width')]) === null || _a === void 0 ? void 0 : _a.width) || getSize(size, 'width')};
            height: ${((_b = dialogSizeStyles[getSize(size, 'height')]) === null || _b === void 0 ? void 0 : _b.height) || getSize(size, 'height')};
        `;
    }
    return (0, styled_components_1.css) `
        width: ${dialogSizeStyles[size].width};
        height: ${dialogSizeStyles[size].height};
    `;
};
exports.StyledDialog = styled_components_1.default.div `
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    background-color: ${Dialog_1.dialogTokens.dialogBackgroundColor.getVar()};
    box-shadow: ${Dialog_1.dialogTokens.dialogBoxShadow.getVar()};
    border: ${Dialog_1.dialogTokens.dialogBorderWidth.getVar()} solid
        ${Dialog_1.dialogTokens.dialogBorderColor.getVar()};
    border-radius: ${Dialog_1.dialogTokens.dialogBorderRadius.getVar()};

    font-size: ${Dialog_1.dialogTokens.dialogContentFontSize.getVar()};
    font-weight: ${Dialog_1.dialogTokens.dialogContentFontWeight.getVar()};
    font-family: ${Typography_1.typographyTokens.fontFamily.getVar()};
    outline: none;

    ${({ size }) => (0, styled_components_1.css) `
        ${setDialogSizeStyles(size)}
    `}

    ${({ moving }) => moving &&
    (0, styled_components_1.css) `
            user-select: none;
        `}
`;
exports.StyledDialogHeaderTitle = styled_components_1.default.h2 `
    ${typographyReset_1.typographyReset};
    flex-grow: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: ${Dialog_1.dialogTokens.dialogHeaderTitleFontSize.getVar()};
    font-weight: ${Dialog_1.dialogTokens.dialogHeaderTitleFontWeight.getVar()};
    line-height: ${Dialog_1.dialogTokens.dialogHeaderTitleLineHeight.getVar()};
`;
exports.StyledDialogHeader = styled_components_1.default.header `
    flex-shrink: 0;
    display: flex;
    align-items: center;
    user-select: none;
    box-sizing: border-box;
    color: ${Dialog_1.dialogTokens.dialogHeaderColor.getVar()};
    background-color: ${Dialog_1.dialogTokens.dialogHeaderBackgroundColor.getVar()};
    height: ${Dialog_1.dialogTokens.dialogHeaderHeight.getVar()};
    padding-right: ${({ hasClose }) => hasClose
    ? Dialog_1.dialogTokens.dialogHeaderPaddingRight.getVar()
    : Dialog_1.dialogTokens.dialogHeaderPaddingLeft.getVar()};
    padding-left: ${Dialog_1.dialogTokens.dialogHeaderPaddingLeft.getVar()};
    margin-top: calc(-1 * ${Dialog_1.dialogTokens.dialogBorderWidth.getVar()});
    cursor: move;
    outline: none;

    ${WindowClose_1.WindowClose.selector} {
        top: calc(-1 * ${Dialog_1.dialogTokens.dialogBorderWidth.getVar()});
        right: calc(-1 * ${Dialog_1.dialogTokens.dialogBorderWidth.getVar()});
    }
`;
exports.StyledDialogBody = styled_components_1.default.div `
    flex-grow: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;
exports.StyledDialogContent = (0, styled_components_1.default)(View_1.View) `
    flex-grow: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;

    ${({ hasSpacing }) => hasSpacing &&
    (0, styled_components_1.css) `
            padding: ${Dialog_1.dialogTokens.dialogContentPaddingVertical.getVar()}
                ${Dialog_1.dialogTokens.dialogPaddingHorizontal.getVar()};
        `}

    ${({ hasTopPadding }) => !hasTopPadding &&
    (0, styled_components_1.css) `
            padding-top: 0;
        `};
`;
exports.StyledDialogFooter = styled_components_1.default.footer `
    flex-shrink: 0;
    padding: ${Dialog_1.dialogTokens.dialogFooterPaddingVertical.getVar()}
        ${Dialog_1.dialogTokens.dialogPaddingHorizontal.getVar()};
    border-top: ${Dialog_1.dialogTokens.dialogFooterBorderWidth.getVar()} solid
        ${Dialog_1.dialogTokens.dialogFooterBorderColor.getVar()};
    text-align: right;
`;
//# sourceMappingURL=Dialog.styles.js.map